import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  sectionTitle: {
    marginBottom: 30
  },
  subsection: {
    marginBottom: 30
  }
})

export default useStyles
